import { render, staticRenderFns } from "./LiteratureCart.vue?vue&type=template&id=765882a2"
import script from "./LiteratureCart.vue?vue&type=script&lang=js"
export * from "./LiteratureCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports